<template>
  <div id="filters-container">
    <p class="mb-0 ml-3 mt-4 text-center">Filter by</p>

    <div class="btn-reset-ctn">
      <b-button
        class="filter-button btn-reset"
        variant="outline-*"
        @click="resetFilters"
      >
        <img :src="getIcon('resetBtn.svg')" alt />
        <p class="filter-name">Reset filters</p>
      </b-button>
    </div>
    <div
      v-for="(filterGroup, key) in store.filtersList"
      :key="key"
      :title="key"
      active
    >
      <b-button
        v-b-toggle="key.replaceAll(' ', '-')"
        class="filter-button"
        variant="outline-*"
      >
        <img :src="getIcon(filterGroup.icon)" alt />
        <img class="filter-arrow" src="@/assets/filterArrow.png" alt />
        <p class="filter-name text-uppercase">{{ key }}</p>
      </b-button>
      <b-collapse
        :id="key.replaceAll(' ', '-')"
        @shown="setAlloysListHeight()"
        @hidden="setAlloysListHeight()"
      >
        <div class="section-filters">
          <span
            v-if="filterGroup.type === 'checkbox-forms-sizes'"
            class="checkbox-container"
          >
            <span>
              <input
                id="allFormsAndSizes"
                v-model="store.allFormsAndSizesSelected"
                class="checkbox"
                type="checkbox"
                value="all"
                @change="changeFormsAndSizes"
              />
              <label for="allFormsAndSizes">All</label>
            </span>
            <span v-for="filter in filterGroup.datas" :key="filter.filterName">
              <input
                :id="filter.filterName"
                v-model="store.formsAndSizesSelected"
                :value="filter.technicalId"
                class="checkbox"
                type="checkbox"
                @change="changeFormsAndSizes"
              />
              <label :for="filter.filterName">{{ filter.filterName }}</label>
            </span>
          </span>
          <span v-else-if="filterGroup.type === 'slider'">
            <div v-for="filter in filterGroup.datas" :key="filter.filterName">
              <div class="filter-item slider">
                <div v-if="Array.isArray(filter.unit)">
                  <div class="switch-header">
                    <span class="filter-name">{{ filter.filterName }}</span>
                    <span class="switch">
                      {{ filter.unit[0].name }}
                      <b-form-checkbox
                        v-model="filter.selectedUnit"
                        name="check-button"
                        switch
                        class="unit-switch"
                        @change="checkboxChange(filter, filterGroup.type)"
                      ></b-form-checkbox>
                      {{ filter.unit[1].name }}
                    </span>
                  </div>
                  <VueSlider
                    v-model="filter.selectedValue"
                    :min="filter.min"
                    :max="filter.max"
                    :interval="filter.interval"
                    :tooltip="'always'"
                    @drag-end="
                      addFilter(
                        filter.selectedUnit
                          ? filter.technicalId[1]
                          : filter.technicalId[0],
                        filterGroup.type,
                        filter.selectedValue
                      )
                    "
                  ></VueSlider>
                </div>
                <div v-else>
                  <span class="filter-name">{{ filter.filterName }}</span>
                  <VueSlider
                    v-model="filter.selectedValue"
                    :min="filter.min"
                    :max="filter.max"
                    :interval="filter.interval"
                    :tooltip="'always'"
                    @drag-end="
                      addFilter(
                        filter.technicalId,
                        filterGroup.type,
                        filter.selectedValue
                      )
                    "
                  ></VueSlider>
                </div>
              </div>
            </div>
          </span>
          <span v-else-if="filterGroup.type === 'select'">
            <div v-for="filter in filterGroup.datas" :key="filter.filterName">
              <div class="row my-3">
                <div class="col-5">{{ filter.filterName }}</div>
                <div class="col-7">
                  <b-form-checkbox-group
                    v-model="filter.value"
                    :options="[1, 2, 3, 4, 5]"
                    buttons
                    @change="
                      $nextTick(() => {
                        addFilter(
                          filter.technicalId,
                          filterGroup.type,
                          filter.value
                        );
                      })
                    "
                  ></b-form-checkbox-group>

                  <img
                    v-b-modal.help-modal
                    class="help-button"
                    src="@/assets/help.png"
                    alt
                  />
                </div>
              </div>
            </div>
          </span>
          <span v-else-if="filterGroup.type === 'univers-selection'">
            <UniversFilter
              :clear-selection="clearSelection"
              :universes-list="universesList"
            />
          </span>
        </div>
      </b-collapse>
    </div>

    <b-modal id="help-modal" centered hide-footer hide-header size="lg">
      <img
        class="close-help-modal"
        src="@/assets/close-modal.png"
        alt
        @click="close()"
      />
      <img class="mt-5" src="@/assets/help.png" alt />
      <p class="help-title mt-3 mb-5">
        Explanation of the 1 to 5 rating concerning the surface properties:
      </p>
      <b-row>
        <b-col>
          <p class="help-subtitle">Corrosion resistance level:</p>
          <ol>
            <li>1: not recommended</li>
            <li>2: poor</li>
            <li>3: fair</li>
            <li>4: good</li>
            <li>5: excellent</li>
          </ol>
        </b-col>
        <b-col>
          <p class="help-subtitle">Friction behavior level when dry:</p>
          <ol>
            <li>1: not recommended</li>
            <li>2: poor resistance to galling and wear</li>
            <li>3: resistant to galling, fair wear resistance</li>
            <li>4: resistant to galling, good wear resistance</li>
            <li>
              5: resistant to galling, excellent wear resistance
            </li>
          </ol>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import UniversFilter from "@/components/UniversFilter";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import Store from "@/store";
import axios from "axios";
import $ from "jquery";

export default {
  components: {
    VueSlider,
    UniversFilter
  },
  props: {
    alloys: {
      type: Array,
      required: true
    },
    clearSelection: {
      type: Function,
      required: true
    },
    clearSorting: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      store: Store.state,
      test: 1.1,
      universesList: []
    };
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
    const token = process.env.VUE_APP_ROOT_API_GET_TOKEN;
    if (token) {
      axios.defaults.headers.common["Cockpit-Token"] = token;
      axios
        .get("collections/get/universes")
        .then(response => {
          this.universesList = response.data.entries;
          this.store.productUniverses = this.universesList.map(
            u => u.universName
          );
          this.loader = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }

    // Initialisation des forms and sizes
    Store.initFormsAndSizes();
  },
  methods: {
    close() {
      this.$bvModal.hide("help-modal");
    },
    changeFormsAndSizes(event) {
      Store.changeFormsAndSizes(event.target.value);
    },
    checkboxChange(filter, type) {
      /**
       * Si un filtre a été mis sur l'autre unité, on le supprime
       * Sachant que lorsqu'on clic on a l'état précédent de la checkbox.
       * Donc si on fait passer la checkbox à True, ici on a filter.selectedUnit à false
       */

      Store.deleteFilter(
        filter.selectedUnit ? filter.technicalId[1] : filter.technicalId[0]
      );

      // Mise à jour des paramètres utilisés par le slider
      let unitMin = filter.selectedUnit
        ? filter.unit[0].valueMin
        : filter.unit[1].valueMin;
      let unitMax = filter.selectedUnit
        ? filter.unit[0].valueMax
        : filter.unit[1].valueMax;
      let unit = filter.selectedUnit
        ? filter.technicalId[0]
        : filter.technicalId[1];
      let operator = filter.selectedUnit
        ? filter.unit[0].operator
        : filter.unit[1].operator;

      filter.min = unitMin;

      if (!operator) {
        filter.max = unitMax;
        if (filter.selectedValue > unitMax) {
          filter.selectedValue = unitMax;
        }
        this.addFilter(unit, type, filter.selectedValue);
        return;
      }

      let newValue =
        operator == "multiply"
          ? (filter.selectedValue * filter.coefficient).toFixed(0)
          : (filter.selectedValue / filter.coefficient).toFixed(0);

      // Si la valeur courante est plus grande que la valeur max future
      if (newValue >= unitMax) {
        this.$nextTick(() => {
          filter.selectedValue = newValue;
          filter.max = unitMax;
          this.addFilter(unit, type, newValue);
        });
      } else {
        filter.max = unitMax;
        filter.selectedValue = newValue;
        this.addFilter(unit, type, filter.selectedValue);
      }
    },
    getIcon(iconName) {
      return require("@/assets/" + iconName);
    },
    addFilter(property, type, value) {
      Store.addFilter(property, type, value);
    },
    resetFilters() {
      this.clearSorting();
      Store.resetFilters(this.universesList);
    },
    setAlloysListHeight() {
      const alloyFilterHeight = $("#filters-container").outerHeight();
      // Espace supplémentaire correspondant au contenu au-dessus des filtres (tri + espacements)
      const additionnalSpace = 85;
      $("#alloys-list").height(alloyFilterHeight + additionnalSpace);
    }
  }
};
</script>

<style lang="scss">
div {
  &.specific-filter-ctn {
    height: 25%;
    min-height: 72px;
    background: rgba(255, 255, 255, 0.4);
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    display: flex;
    align-items: center;
  }
}
button {
  &.filter-button {
    height: 25%;
    min-height: 72px;
    width: 100%;
    border-radius: 0;
    background: rgba(255, 255, 255, 0.4);
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    text-align: left;
    font-size: 1.3em;
    font-weight: bold;
  }
  img {
    margin: 0 10px;
    width: 32px;
  }
  &.collapsed {
    .filter-arrow {
      transform: rotate(0);
    }
  }
}
.btn-reset-ctn {
  background-color: rgba(207, 87, 57, 0.3);
  transition: background-color 0.3s ease;
  &:hover {
    background-color: rgba(207, 87, 57, 0.5);
  }
  .btn-reset {
    text-align: center;
  }
  img {
    margin-left: 0;
  }
}
.section-filters {
  background: rgba(255, 255, 255, 0.2);
  padding: 30px;
}
.filter-arrow {
  width: 16px;
  transform: rotate(90deg);
  transition: all 0.2s ease;
}
.filter-name {
  display: inline-block;
  font-size: 16px;
  color: #5e5e5e;
  margin-bottom: 0;
  vertical-align: middle;
}
.filter-item {
  margin: 25px;
  text-align: left;
  font-weight: bold;

  p {
    margin-bottom: 4px;
  }
  .vue-slider-process {
    background-color: #ccc;
  }
  .vue-slider-rail {
    background-image: linear-gradient(
      to right,
      #6a2515,
      #8c4430,
      #ae634d,
      #d1846c,
      #f4a68d
    );
  }
  .vue-slider.vue-slider-ltr {
    height: 11px !important;
  }
  .vue-slider-dot-tooltip-top {
    left: -10px;
    top: -20px;
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  .vue-slider-dot-tooltip-inner {
    background: linear-gradient(to right, #ffffff, #ebebeb);
    border: 6px solid rgb(230, 230, 230);
    color: #d36c48;
    font-weight: bold;
    padding: 0;
    border-radius: 40px;
    height: 40px;
    width: 40px;
    .vue-slider-dot-tooltip-text {
      margin-top: 10px;
      display: block;
    }
    &::after {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
span.filter-name {
  margin-bottom: 20px;
}
.checkbox-container span {
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  .checkbox {
    -webkit-appearance: none;
    background-color: #fafafa;
    border: 3px solid #b9b9b9;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    width: 24px;
    height: 24px;
    padding: 9px;
    border-radius: 30px;
    display: inline-block;
    position: relative;
    margin-right: 5px;
    margin-top: -5px;
    vertical-align: middle;
    &:hover {
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }
    &:checked {
      border: 3px solid #d36c48;
    }
  }
}
.switch-header {
  margin-bottom: 20px;

  span.switch {
    float: right;
    margin-bottom: 20px;
    color: #5e5e5e;
  }
  .custom-switch.unit-switch {
    display: inline-block;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #d36c48;
    background-color: #d36c48;
  }
  .custom-switch .custom-control-label::after {
    background-color: #d36c48;
  }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #d36c48 !important;
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
}
label.btn.btn-secondary {
  background-color: lighten(#d36c48, 10%);
  border-color: darken(#d36c48, 10%);
  &:hover {
    background-color: #d36c48;
    cursor: pointer;
  }
  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    background-color: darken(#d36c48, 10%);
    border-color: darken(#d36c48, 10%);
  }
  &:focus {
    box-shadow: none;
  }
}

.help-button {
  position: absolute;
  right: -8px;
  top: 4px;
  cursor: pointer;
}
#help-modal {
  .close-help-modal {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  p.help-title {
    font-size: 32px;
    line-height: 1.2;
  }
  p.help-subtitle {
    color: #d83e20;
    font-size: 24px;
  }
  ol {
    list-style: none;
    font-size: 16px;
    text-align: left;
  }
}
</style>
